import React from 'react';
import { useNavigate } from 'react-router-dom';
import Wrapper from '../../components/Wrapper';
import ROUTES from '../../utils/routes';
import './ReportsHealthyList.scss';
import { useReportHealth } from '../../hooks/useReportHealth';
import Loader from '../../components/Loader';
import { useTranslation } from '../../hooks/useTranslation';

const ReportsHealthyList = () => {
    const {t} = useTranslation();
    const { data: reportHealth, isLoading } = useReportHealth();
    const navigate = useNavigate();

    const handleFacilityClick = (id) => {
        navigate(ROUTES.private.reportsHealthy(id));
    };

    if (isLoading) {
        return (
            <Wrapper>
                <div className="reports-healthy-list">
                    <div className="reports-healthy-list__container">
                        <Loader />
                    </div>
                </div>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            <div className="reports-healthy-list">
                <div className="reports-healthy-list__container">
                    <div className="reports-healthy-list__header">
                        <h1 className="reports-healthy-list__title">
                            {t('reportsHealthyList.title')}
                        </h1>
                        <span>{t('reportsHealthyList.schedule')}</span>
                    </div>

                    <div className="reports-healthy-list__table-container">
                        <div className="reports-healthy-list__table-wrapper">
                            <table className="reports-healthy-list__table">
                                <thead>
                                    <tr>
                                        <th>{t('reportsHealthyList.tableHeaders.title')}</th>
                                        <th>{t('reportsHealthyList.tableHeaders.status')}</th>
                                        <th>{t('reportsHealthyList.tableHeaders.completed')}</th>
                                        <th>{t('reportsHealthyList.tableHeaders.failed')}</th>
                                        <th>{t('reportsHealthyList.tableHeaders.total')}</th>
                                        <th>{t('reportsHealthyList.tableHeaders.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportHealth?.map((facility) => (
                                        <tr 
                                            key={facility.id}
                                            className="reports-healthy-list__row"
                                            onClick={() => handleFacilityClick(facility.id)}
                                        >
                                            <td>
                                                <span className="facility-name">{facility.title}</span>
                                            </td>
                                            <td>
                                                <span className={`status-badge status-${facility.status}`}>
                                                    {facility.status}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`status-badge completed`}>
                                                    {facility.completedLogs}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`status-badge failed`}>
                                                    {facility.failedLogs}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`status-badge total`}>
                                                    {facility.total}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="action-arrow" title={t('reportsHealthyList.actions.view')}>→</div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default ReportsHealthyList;